module.exports = __webpack_public_path__ + "static/img/App item-2.004fe9d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-live/swiper2/App item-2.png
// module id = Bohh
// module chunks = 12